import clsx from 'clsx';

interface BackgroundProps {
  image: string;
  overlay?: boolean | string;
  position?:
    | string
    | {
        x?: string;
        y?: string;
      };
  video?: Array<string>;
  className?: string;
  style?: React.CSSProperties;
}

const Background = ({
  image,
  overlay,
  position,
  video,
  className,
  style,
}: BackgroundProps) => {
  const bgStyle = { backgroundImage: `url(${image})`, ...style };
  if (typeof position === 'string') {
    bgStyle.backgroundPosition = position;
  } else if (typeof position === 'object') {
    if (position.x) bgStyle.backgroundPositionX = position.x;
    if (position.y) bgStyle.backgroundPositionY = position.y;
  }

  return (
    <div
      className={clsx(
        'bg-holder',
        {
          overlay: overlay,
          [`overlay-${overlay?.toString() as string}`]:
            typeof overlay === 'string',
        },
        className,
      )}
      style={bgStyle}
    >
      {video && (
        <video className='bg-video' autoPlay loop muted playsInline>
          {video.map((src, index) => (
            <source
              key={index}
              src={src}
              type={`video/${src.split('.').pop() as string}`}
            />
          ))}
        </video>
      )}
    </div>
  );
};

export default Background;
